import React from 'react'
import { get, pick } from 'lodash-es'
// import clsx from 'clsx'
import { ErrorBoundary } from 'react-error-boundary'
import {
  TbViewProvider,
  useTbViewStore,
  useFetchRemoteData,
  useBeforeTransform,
  useProjectStore,
} from '@vt/hooks'
import { ModalsProvider } from '@mantine/modals'
import { DittoProvider } from '@ow/ditto-core'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { upload, addWatermarkToImage } from '@vt/apis/lib-ex/v2/givrali'
import NavMenuOperate from '../container/container-render/NavMenuOperate'
import ContainerRender from '../container/container-render'
// import useInlineEdit from '../data-operate/inline/use-edit'
import Calendar from '../container/container-render/Calendar'
import Log from '../container/container-render/Log'
import DataOperateProvider from '../data-operate/DataOperateProvider'

const LeftContent = styled.div`
  @media (min-width: 768px) {
    width: 368px;
  }
  ${tw`flex-col w-full md:gap-0 md:h-full flex`}
`

// const showDataTypes = ['list', 'calendar', 'article', 'file', 'map']
const ViewContentRender = function ({
  showNavMenu = true,
  autoFetchData = true,
}) {
  const {
    showRecycle,
    layouts = {},
    punchInConfig,
  } = useTbViewStore((state) =>
    pick(state, ['layouts', 'showRecycle', 'punchInConfig'])
  )

  const allowLog =
    punchInConfig && punchInConfig.allowLog && !punchInConfig.allowLog.hidden
  const allowCalendar =
    punchInConfig &&
    punchInConfig.allowCalendar &&
    !punchInConfig.allowCalendar.hidden

  console.log('[1]', useTbViewStore())

  const showLayouts = showRecycle ? layouts.recycleLayouts : layouts.layouts
  if (showLayouts && !showLayouts.elements.length) return null
  return (
    <DataOperateProvider>
      <div
        className="flex flex-col overflow-hidden flex-1"
        style={{ margin: '14px', gap: '14px' }}
      >
        <NavMenuOperate
          layouts={showNavMenu && showLayouts && showLayouts.navMenu}
        />
        <div className="flex gap-2 h-full flex-1">
          {(allowLog || allowCalendar) && (
            <LeftContent>
              {allowCalendar && (
                <div className="w-full md:h-1/2 bg-white md:mb-0 md:rounded-none mb-4 flex items-center justify-center rounded-md">
                  <Calendar />
                </div>
              )}
              {allowLog && (
                <div className="w-full md:h-1/2 bg-white md:mb-0 md:rounded-none rounded-md mb-4">
                  <Log />
                </div>
              )}
            </LeftContent>
          )}
          <div className="flex flex-col gap-2 h-full flex-1">
            <ErrorBoundary fallback={<div>layouts渲染错误</div>}>
              {get(showLayouts, 'elements', [])
                .filter((element) => !element.hidden)
                .map((element, index) => {
                  return (
                    <ContainerRender
                      key={`${element}-${index}`}
                      layouts={element}
                      // showTbInlineEdit={showTbInlineEdit}

                      autoFetchData={autoFetchData}
                    />
                  )
                })}
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </DataOperateProvider>
  )
}

const TbViewPunchIn = function ({
  appId,
  tbId,
  vid,
  extendsStore,
  showNavMenu,
  children,
  autoFetchData,
}) {
  console.log(tbId, 'tbId')
  const fetchRemoteData = useFetchRemoteData()
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )
  const beforeTransform =
    customCompsMap && customCompsMap.useBeforeTransform
      ? customCompsMap.useBeforeTransform
      : useBeforeTransform
  return (
    <DittoProvider
      tbId={tbId}
      onFetchRemoteData={fetchRemoteData}
      upload={upload}
      addWatermarkToImage={addWatermarkToImage}
      beforeTransform={beforeTransform}
    >
      <TbViewProvider
        appId={appId}
        tbId={tbId}
        vid={vid}
        extendsStore={extendsStore}
      >
        <ModalsProvider>{children}</ModalsProvider>
        <ViewContentRender
          showNavMenu={showNavMenu}
          autoFetchData={autoFetchData}
        />
      </TbViewProvider>
    </DittoProvider>
  )
}

export default TbViewPunchIn
